import "jquery";
import * as ko from "knockout";
import { MasterDataApi } from "../Apis/MasterDataApi";
import { MasterData } from "../Models/MasterData";

export class ChangeMasterDataViewModel {
    masterDataApi: MasterDataApi;
    requestSubmitted = ko.observable(false);
    showSpinner = ko.observable(false);

    submit(): void {
        this.showSpinner(true);
        console.log(this.getValue("PhoneNo4"));
        let masterData = new MasterData();
        masterData.GrowerId = this.getValue("GrowerId");
        masterData.Name = this.getValue("Name");
        masterData.Name2 = this.getValue("Name2");
        masterData.Address = this.getValue("Address");
        masterData.Address2 = this.getValue("Address2");
        masterData.PostCode = this.getValue("PostCode");
        masterData.City = this.getValue("City");
        masterData.Contact = this.getValue("Contact");
        masterData.DeliveryAddress = this.getValue("DeliveryAddress");
        masterData.CompanyName = this.getValue("CompanyName");
        masterData.VatNo = this.getValue("VatNo");
        masterData.CprNo = this.getValue("CprNo");
        masterData.Constituency = this.getValue("Constituency");
        masterData.Delegate = this.getValue("Delegate");
        masterData.OrganicAuthNo = this.getValue("OrganicAuthNo");
        masterData.Email = this.getValue("Email");
        masterData.PhoneNo = this.getValue("PhoneNo");
        masterData.PhoneNoText = this.getValue("PhoneNoText");
        masterData.CellPhoneNo = this.getValue("CellPhoneNo");
        masterData.CellPhoneNoText = this.getValue("CellPhoneNoText");
        masterData.PhoneNo2 = this.getValue("PhoneNo2");
        masterData.PhoneNo2Text = this.getValue("PhoneNo2Text");
        masterData.PhoneNo3 = this.getValue("PhoneNo3");
        masterData.PhoneNo3Text = this.getValue("PhoneNo3Text");
        masterData.PhoneNo4 = this.getValue("PhoneNo4"); 
        masterData.PhoneNo4Text = this.getValue("PhoneNo4Text");
        masterData.CellPhoneNo2 = this.getValue("CellPhoneNo2");
        masterData.CellPhoneNo2Text = this.getValue("CellPhoneNo2Text");

        this.masterDataApi.postChangeRequest(masterData).then(() => {
            this.requestSubmitted(true);
            this.showSpinner(false);
        });
    }

    getValue(id: string): string {
        if (($("#" + id).val() as string) == ($("#Original" + id).val() as string)) {
            return $("#" + id).val() as string;
        } else {
            return "<b>" + ($("#" + id).val() as string) + "*</b>";
        }
    }

    init(): void {
        this.masterDataApi = MasterDataApi.getInstance();
    }

    close(): void {
        this.delay(1000).then(() => {
            this.requestSubmitted(false);
        });
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}